import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';

import { withIcon } from './modules/core/components/Icon.tsx';

const SpinnerIcon = withIcon(faSpinnerThird);

const AppLoadingScreen = () => (
    <div className="flex h-dvh w-full items-center justify-center" role="status" aria-busy="true">
        <SpinnerIcon spin className="text-3xl text-content-weak" />
    </div>
);

export default AppLoadingScreen;
